import { useRouter } from 'next/router';
import { DefaultSeo as NextSeoDefault } from 'next-seo';

import { isProd } from 'utils/env.utils';
import { urlFor } from 'utils/routes.utils';

const DefaultSeo = () => {
  const { asPath, defaultLocale, locale, locales = [] } = useRouter();

  const languageAlternates = [...locales, 'x-default'].map((locale) => ({
    hrefLang: locale,
    href:
      locale === defaultLocale || locale === 'x-default'
        ? urlFor(asPath)
        : urlFor(`/${locale}${asPath}`),
  }));
  const canonicalUrl =
    locale === defaultLocale ? urlFor(asPath) : urlFor(`/${locale}${asPath}`);

  return (
    <NextSeoDefault
      dangerouslySetAllPagesToNoFollow={!isProd}
      dangerouslySetAllPagesToNoIndex={!isProd}
      canonical={canonicalUrl}
      openGraph={{
        type: 'website',
        images: [{ url: '/images/social-media.png' }],
        url: urlFor(asPath),
      }}
      languageAlternates={languageAlternates}
    />
  );
};

export default DefaultSeo;
